<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">룸 스케줄</span>
            <span class="txt">예약된 센터의 룸 스케줄을 날짜별, 시간대별로 확인할 수 있습니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="right">
                    <select-form
                        :select-data="selectFormCenter.data"
                        :select-value="selectFormCenter.value"
                        :selected-value="selectedCenterId"
                        @update:set="onUpdateSelectedCenter"
                    />
                    <div v-click-outside="outsideClick" :class="{ on: selectRoomOpen }" class="ui-select">
                        <button @click="selectRoomOpen = !selectRoomOpen"><span class="txt">룸 선택</span></button>
                        <ul>
                            <li>
                                <div class="com-check">
                                    <input
                                        id="select-check-all"
                                        v-model="isCheckAllRooms"
                                        name="select-check-all"
                                        type="checkbox"
                                        @change="onChangeCheckAllRooms"
                                    />
                                    <label for="select-check-all">전체선택</label>
                                </div>
                            </li>
                            <li v-for="room in centerRooms">
                                <div class="com-check">
                                    <input
                                        :id="`select-check-${room.centerRoomId}`"
                                        v-model="room.checked"
                                        :name="`select-check-${room.centerRoomId}`"
                                        type="checkbox"
                                        @change="onChangeCheckRoom"
                                    />
                                    <label :for="`select-check-${room.centerRoomId}`">{{ room.name }}</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <button class="com-search-reset"></button>
                </div>
            </div>
            <div class="line">
                <schedule-date-selector
                    :callback-update-date="onUpdateScheduleDateSelector"
                    :selected-date="selectedDate"
                ></schedule-date-selector>
                <div class="right">
                    <button class="top-link-btn" @click="goTo('/madmin/schedule/day')">일일스케줄</button>
                    <button class="top-link-btn" @click="goTo('/madmin/schedule/group')">그룹 주간표</button>
                    <button class="top-link-btn" @click="goTo('/madmin/schedule/teacher')">강사 주간표</button>
                    <button class="top-link-btn on">룸 스케줄표</button>
                    <!--                    <button class="top-link-btn green" @click="reservationPop = true">신규예약</button>-->
                    <button class="com-setting-btn" @click="timePop = true"><span class="blind">설정</span></button>
                </div>
            </div>
        </div>

        <div class="schedule-table-content room">
            <table class="schedule-table">
                <colgroup>
                    <col style="width: 100px" />
                    <col v-for="n in tableColKeyData" v-if="n.reserveYn" style="width: 190px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <!--                            <button class="prev-btn"><span class="blind">이전</span></button>-->
                            <!--                            <button class="next-btn"><span class="blind">다음</span></button>-->
                        </th>
                        <th v-for="room in tableColKeyData" v-if="room.reserveYn">{{ room.name }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="hour in tableRowKeyData">
                        <td>{{ `${hour}:00` }}</td>
                        <td v-for="room in checkedRooms" v-if="room.reserveYn">
                            <template
                                v-if="
                                    !isEmpty(scheduleTable[room.centerRoomId]) &&
                                    !isEmpty(scheduleTable[room.centerRoomId][hour]) &&
                                    room.reserveYn
                                "
                            >
                                <div
                                    :class="`grid-area num-${scheduleTable[room.centerRoomId][hour].cols}`"
                                    style="border-width: 0px"
                                >
                                    <template v-for="(d, key) in scheduleTable[room.centerRoomId][hour].lessonList">
                                        <div
                                            :key="key"
                                            :class="scheduleClass(d)"
                                            :style="scheduleStyle(d)"
                                            class="item-box"
                                            @mouseleave="onMouseleaveSchedule(d)"
                                            @mouseover="onMouseoverSchedule(d)"
                                        >
                                            <div class="top-line">
                                                <span v-if="d.lessonsType !== 'G'" class="name">
                                                    {{ d.customerName }}
                                                </span>
                                                <span v-else class="name">{{ d.lessonsName }}</span>
                                                <span class="time">{{ d.teacherName }}</span>
                                                <span
                                                    v-if="
                                                        isShowLessonType(d, scheduleTable[room.centerRoomId][hour].cols)
                                                    "
                                                    class="type"
                                                >
                                                    ({{ d.lessonsType }})
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                    <!--
                                <div  v-for="(timeBox, key) in scheduleTable[room.centerRoomId][hour].times"
                                      @mouseover="onMouseoverSchedule(timeBox)"
                                      @mouseleave="onMouseleaveSchedule(timeBox)"
                                      :style="scheduleStyle(timeBox)"
                                      :class="scheduleClass(key)" class="item-box">
                                    <ul class="list">
                                        <li v-for="lesson in timeBox.lessonList">
                                            <span class="icon" :style="`background-color:${lesson.teacherColor}`"></span>
                                            <span class="txt"><span class="name">{{lesson.teacherName}}</span> - <span class="name">{{lesson.customerName}}</span></span>
                                            <span class="type">({{lesson.lessonType}})</span>
                                        </li>
                                    </ul>
                                </div>
                                --></div>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- 스케줄표 시간설정 팝업 -->
        <schedule-time-setter-dlg
            :callback-cancel="onCancelScheduleTimeSetterDlg"
            :callback-confirm="onConfirmScheduleTimeSetterDlg"
            :end-hour="searchTime.endHour"
            :end-min="searchTime.endMin"
            :is-show="timePop"
            :start-hour="searchTime.startHour"
            :start-min="searchTime.startMin"
        ></schedule-time-setter-dlg>
    </div>
</template>

<script>
import moment from 'moment';
import api from '@/assets/js/api';
import { Utils } from '@/assets/js/utils';
import ScheduleTimeSetterDlg from '@/components/ScheduleTimeSetterDlg';
import ScheduleDateSelector from '@/components/ScheduleDateSelector';
import TeacherScheduleDlg from '@/components/TeacherScheduleDlg';

export default {
    name: 'scheduleRoom',
    components: {
        TeacherScheduleDlg,
        ScheduleTimeSetterDlg,
        ScheduleDateSelector,
    },
    props: {},
    computed: {
        tableColKeyData() {
            return this.checkedRooms;
        },
        tableRowKeyData() {
            const res = [];
            const start = parseInt(this.searchTime.startHour);
            const end = parseInt(this.searchTime.endHour);

            for (let i = start; i <= end; i++) {
                res.push(i.toString().padStart(2, '0'));
            }

            return res;
        },
        topZIndex() {
            return 999;
        },
    },
    data() {
        return {
            centerId: '',
            selectedCenterId: '',
            staffId: '',
            centerRooms: [],
            checkedRooms: [],
            selectedDate: moment().format('YYYY-MM-DD'),
            scheduleList: [],
            scheduleTable: {},
            searchTime: {
                startHour: '06',
                startMin: '00',
                endHour: '23',
                endMin: '00',
            },
            selectFormCenter: {
                data: ['센터명'],
                value: [''],
            },
            selectRoomOpen: false,
            timePop: false, // 스케줄표 시간설정 팝업
            isCheckAllRooms: true,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            // 로컬스토리지에 저장한 시간이
            if (this.checkSearchTime()) {
                // 있을경우..
                this.searchTime.startHour = localStorage.getItem('startTime');
                this.searchTime.endHour = localStorage.getItem('endTime');
            }

            this.centerId = parseInt(this.$store.getters['auth/cId']);
            this.staffId = parseInt(this.$store.getters['auth/staffId']);

            // 센터 선택
            await this.fetchCenterChains();
            this.selectedCenterId = this.centerId;

            await this.initWithSelectedCenter();
        },
        checkSearchTime() {
            let answer = false;
            try {
                const startTime = localStorage.getItem('startTime');
                const endTime = localStorage.getItem('endTime');
                if (startTime) answer = true;
                if (endTime) answer = true;
            } catch (error) {
                answer = false;
            }
            return answer;
        },
        async initWithSelectedCenter() {
            // 센터 룸 조회
            await this.fetchCenterRooms();
            this.checkAllRooms(this.isCheckAllRooms);

            await this.fetchRoomScheduleTable();
        },
        async fetchRoomScheduleTable() {
            try {
                const { data } = await this.getRoomSchedule();

                this.scheduleTable = {};

                let zIndex = 200; // z-index를 5000부터 시작함
                const searchEndHour = moment(parseInt(this.searchTime.endHour) + 1, 'HH');

                // 2021.04.20 : 룸 스케줄 UI 변경
                for (const d of data) {
                    /*
                      스케줄 데이터 구성
                      scheduleTable : {
                      roomId : { // 룸 아이디
                      "07" : {  // 레슨 시작 시간 (Hour)
                        count: 2, // 해당 테이블에 걸린 수업 갯수
                        lessonList: [

                         ]
                        },
                      },
                      ......
                      }
                      }
                    */

                    const rmKey = d.centerRoomId;

                    // roomId 데이터가 없으면 생성
                    if (Utils.isEmpty(this.scheduleTable[rmKey])) {
                        this.scheduleTable[rmKey] = {};
                    }

                    // roomId/hour 데이터가 없으면 생성
                    const useStartTime = d.useStartTime.split(':');
                    const tmKey = useStartTime[0];

                    if (Utils.isEmpty(this.scheduleTable[rmKey][tmKey])) {
                        this.scheduleTable[rmKey][tmKey] = {
                            count: 0,
                            lessonList: [],
                        };
                    }

                    const lessonInfo = {
                        teacherName: d.teacher.name,
                        teacherColor: d.teacher.color,
                        lessonsType: d.centerLessonSchedule.lessonsType,
                        lessonsName: d.centerLessonSchedule.lessonName,
                        useStartTime: d.useStartTime,
                        useEndTime: d.useEndTime,
                    };

                    lessonInfo.startMin = parseInt(d.useStartTime.split(':')[1]);
                    // 스케줄표의 종료시간에 따라 크기 변경

                    const lessonEndHour = moment(d.useEndTime, 'HH:mm:ss');
                    const lessonStartTime = moment(d.useStartTime, 'HH:mm:ss');

                    lessonInfo.lessonTotalTime = lessonEndHour.diff(lessonStartTime, 'minutes');
                    if (searchEndHour.isBefore(lessonEndHour)) {
                        lessonInfo.lessonTotalTime = searchEndHour.diff(lessonStartTime, 'minutes');
                    }

                    if (!Utils.isEmpty(d.members) && d.members.length > 0) {
                        lessonInfo.customerName = d.members[0].centerCustomerName;
                    }

                    lessonInfo.zIndex = zIndex;

                    this.scheduleTable[rmKey][tmKey].lessonList.push(lessonInfo);
                    this.scheduleTable[rmKey][tmKey].count++;

                    zIndex++;

                    // 2021.01.12 notbadlife@evb
                    // vue 인스턴스에서 감지하게 하기 위해 객체 유지.
                    // 해당 부분이 없으면 zIndex 변화를 실시간 적용하지 못한다.
                    // scheduleList는 반드시 인스턴스의 데이터에 선언할 것
                    this.scheduleList.push(lessonInfo);
                }

                for (const [roomId, hourObject] of Object.entries(this.scheduleTable)) {
                    for (const [hour, schedule] of Object.entries(hourObject)) {
                        schedule.cols = schedule.count;
                    }
                }

                /*
for(let d of data) {
/*
스케줄 데이터 구성
scheduleTable : {
roomId : { // 룸 아이디
    "07" : {  // 레슨 시작 시간 (Hour)
        times: {  // '시작분_수업시간'을 Key로,
          'min_totaltime' : {
              lessonList: [],
              zIndex: n,
          }
        },
    },
    ......
}
}
** /
const useStartTime = d.useStartTime.split(":");
const rmKey = d.centerRoomId;
const tmKey = useStartTime[0];

// roomId 데이터가 없으면 생성
if(Utils.isEmpty(this.scheduleTable[rmKey])){
this.scheduleTable[rmKey] = {};
}
// roomId/hour 데이터가 없으면 생성
if(Utils.isEmpty(this.scheduleTable[rmKey][tmKey])){
this.scheduleTable[rmKey][tmKey] = {
    times: {},
};
}

let lessonInfo = {
teacherName : d.teacher.name,
teacherColor: d.teacher.color,
lessonType: d.centerLessonSchedule.lessonsType,
};

if(!Utils.isEmpty(d.members) && d.members.length > 0) {
lessonInfo.customerName = d.members[0].centerCustomerName;
}
if(!Utils.isEmpty(d.centerLessonSchedule) && !Utils.isEmpty(d.centerLessonSchedule.lessonTotalTime)) {
lessonInfo.lessonTotalTime = d.centerLessonSchedule.lessonTotalTime;
}
else {
lessonInfo.lessonTotalTime = 60;
}

const minTmKey = `${useStartTime[1]}_${lessonInfo.lessonTotalTime}`;

if(!Utils.isEmpty(this.scheduleTable[rmKey][tmKey].times[minTmKey])){
this.scheduleTable[rmKey][tmKey].times[minTmKey].lessonList.push(lessonInfo);
}
else {
let timeBox = {
    zIndex: zIndex,
    lessonList : [lessonInfo],
};

this.scheduleTable[rmKey][tmKey].times[minTmKey] = timeBox;
this.scheduleList.push(timeBox);

zIndex++;
}


/*
d.zIndex = zIndex;
this.scheduleTable[rmKey][tmKey].lessonList.push(d);
this.scheduleTable[rmKey][tmKey].count++;
** /
// 2021.01.12 notbadlife@evb
// vue 인스턴스에서 감지하게 하기 위해 객체 유지.
// 해당 부분이 없으면 zIndex 변화를 실시간 적용하지 못한다.
// scheduleList는 반드시 인스턴스의 데이터에 선언할 것
}

for(const [roomId, hourObject] of Object.entries(this.scheduleTable)) {
for(const [hour, schedule] of Object.entries(hourObject)) {
schedule.cols = (schedule.count > 4 ? 4 : schedule.count);

}
}
*/
            } catch (e) {
                console.log(e);
                if (e.response.data.error === 'Not Found') {
                    this.scheduleTable = {};
                    this.scheduleList = [];
                } else {
                    Utils.alertResponseErrorMessge(e);
                }
            }
        },
        async fetchCenterChains() {
            try {
                const { data } = await this.getCenterChains();
                const obj = Utils.getSelectFormObjectFromArray('centerName', 'id', data);
                this.selectFormCenter.data = obj.data;
                this.selectFormCenter.value = obj.value;
            } catch (e) {
                console.log(e);
            }
        },
        async fetchCenterRooms() {
            try {
                const { data } = await this.getCenterRooms();
                this.centerRooms = data;
            } catch (e) {
                console.log(e);
            }
        },
        onUpdateSelectedCenter(cId) {
            this.selectedCenterId = cId;
            this.initWithSelectedCenter();
        },
        onUpdateScheduleDateSelector(date) {
            // this.selectedDate = date;
            this.selectedDate = moment(date).format('YYYY-MM-DD');
            this.fetchRoomScheduleTable();
        },
        onChangeCheckAllRooms() {
            this.checkAllRooms(this.isCheckAllRooms);
        },
        onChangeCheckRoom() {
            this.refreshCheckedRooms();
        },
        onCancelScheduleTimeSetterDlg(times) {
            const { startHour, endHour } = times;

            this.searchTime.startHour = startHour;
            this.searchTime.endHour = endHour;

            this.timePop = false;
        },
        onConfirmScheduleTimeSetterDlg(times) {
            const { startHour, endHour } = times;

            this.searchTime.startHour = startHour;
            this.searchTime.endHour = endHour;
            // 시간 값을 저장..
            localStorage.setItem('startTime', startHour);
            localStorage.setItem('endTime', endHour);

            this.timePop = false;

            this.fetchRoomScheduleTable();
        },
        onMouseoverSchedule(item) {
            if (item.zIndex !== this.topZIndex) {
                item._zIndex = item.zIndex;
                item.zIndex = this.topZIndex;
            }
        },
        onMouseleaveSchedule(item) {
            if (!Utils.isEmpty(item._zIndex)) {
                item.zIndex = item._zIndex;
                item._zIndex = '';
            }
        },
        getRoomSchedule() {
            // const targetDate = this.selectedDate.replace(/-/g, '');
            const targetDate = moment(this.selectedDate).format('YYYYMMDD');
            return api.get(`/admin/api/center/${this.selectedCenterId}/lesson/schedule/room/all/${targetDate}`);
        },
        getCenterChains() {
            return api.get(`/admin/api/center/${this.centerId}/chain`);
        },
        getCenterRooms() {
            return api.get(`/admin/api/centerRoom/${this.selectedCenterId}`);
        },
        refreshCheckedRooms() {
            this.checkedRooms = [];
            for (const room of this.centerRooms) {
                if (room.checked) {
                    this.checkedRooms.push(room);
                }
            }
        },
        checkAllRooms(checked) {
            for (const room of this.centerRooms) {
                room.checked = checked;
            }

            this.refreshCheckedRooms();
        },
        scheduleClass(item) {
            return [`m${item.startMin}`, `h${item.lessonTotalTime}`];
        },
        scheduleStyle(item) {
            // :style="`border-color:${d.teacherColor}; z-index: ${d.zIndex}`"
            return {
                borderColor: item.teacherColor,
                zIndex: item.zIndex,
            };
        },
        outsideClick() {
            this.selectOpen = false;
        },
        isEmpty(v) {
            return Utils.isEmpty(v);
        },
        isShowLessonType(item, cols) {
            if (cols === 1) {
                return true;
            } else if (item.lessonTotalTime > 30) {
                return true;
            }
            return false;
        },
    },
};
</script>
<style lang="scss"></style>
